import { createApp } from 'vue'
import SignIntegrationApp from './components/SignIntegrationApp.vue'

const app = createApp(SignIntegrationApp)
app.mount('#app')
